export const GroupByName = [
   {
      name: 'davinci',
      data: [
         'text-davinci-003',
         'davinci',
         'text-davinci-001',
         'text-davinci-insert-002',
         'text-davinci-edit-001',
         'davinci-search-document',
         'code-davinci-edit-001',
         'davinci-instruct-beta',
         'text-search-davinci-query-001',
         'code-davinci-002',
         'davinci-search-query',
         'text-davinci-insert-001',
         'text-davinci-002',
         'text-search-davinci-doc-001',
         'text-similarity-davinci-001',
         'davinci-similarity',
         'davinci:2020-05-03',
         'if-davinci-v2',
         'if-davinci:3.0.0',
         'davinci-if:3.0.0',
         'davinci-instruct-beta:2.0.0',
         'text-davinci:001',
      ],
   },
   {
      name: 'babbage',
      data: [
         'babbage',
         'babbage-code-search-code',
         'text-similarity-babbage-001',
         'babbage-code-search-text',
         'babbage-similarity',
         'code-search-babbage-text-001',
         'code-search-babbage-code-001',
         'babbage-search-document',
         'text-search-babbage-doc-001',
         'babbage-search-query',
         'text-babbage-001',
         'text-search-babbage-query-001',
         'babbage:2020-05-03',
      ],
   },
   {
      name: 'ada',
      data: [
         'text-embedding-ada-002',
         'ada',
         'text-ada-001',
         'text-similarity-ada-001',
         'ada-code-search-code',
         'ada-similarity',
         'code-search-ada-text-001',
         'text-search-ada-query-001',
         'ada-code-search-text',
         'text-search-ada-doc-001',
         'code-search-ada-code-001',
         'ada-search-query',
         'ada-search-document',
         'ada:2020-05-03',
         'text-ada:001',
         'text-babbage:001',
      ],
   },

   {
      name: 'curie',
      data: [
         'curie-instruct-beta',
         'curie-search-query',
         'text-curie-001',
         'text-similarity-curie-001',
         'text-search-curie-doc-001',
         'text-search-curie-query-001',
         'curie-similarity',
         'curie-search-document',
         'curie',
         'curie:2020-05-03',
         'if-curie-v2',
         'text-curie:001',
      ],
   },
   {
      name: 'cushman',
      data: ['code-cushman-001', 'cushman:2020-05-03'],
   },
   {
      name: 'audio',
      data: ['audio-transcribe-deprecated'],
   },
]

export const GroupByFunction = [
   {
      name: 'Natural Language Processing',
      data: [
         'text-davinci-003',
         'text-davinci-002',
         'text-davinci-001',
         'text-davinci-insert-002',
         'text-davinci-edit-001',
         'text-davinci-insert-001',
         'text-davinci:001',
         'babbage',
         'text-babbage-001',
         'text-ada-001',
         'text-curie-001',
         'text-curie:001',
      ],
   },
   {
      name: 'Search Query',
      data: [
         'davinci-search-query',
         'text-search-davinci-query-001',
         'text-search-babbage-query-001',
         'babbage-search-query',
         'ada-search-query',
         'text-search-curie-query-001',
         'curie-search-query',
      ],
   },
   {
      name: 'Similarity',
      data: [
         'text-similarity-davinci-001',
         'davinci-similarity',
         'text-similarity-davinci-001',
         'babbage-similarity',
         'text-similarity-babbage-001',
         'ada-similarity',
         'text-similarity-ada-001',
         'text-similarity-ada-001',
         'curie-similarity',
         'text-similarity-curie-001',
      ],
   },
   {
      name: 'Code',
      data: [
         'code-davinci-edit-001',
         'code-davinci-002',
         'babbage-code-search-text',
         'babbage-code-search-code',
         'babbage-code-search-code',
         'code-search-babbage-text-001',
         'code-search-babbage-code-001',
         'code-search-babbage-text-001',
         'ada-code-search-text',
         'ada-code-search-code',
         'code-search-ada-code-001',
         'code-search-ada-text-001',
         'code-cushman-001',
      ],
   },
   {
      name: 'Search Document',
      data: [
         'davinci-search-document',
         'text-search-davinci-doc-001',
         'text-search-davinci-doc-001',
         'davinci-search-document',
         'babbage-search-document',
         'text-search-babbage-doc-001',
         'babbage-search-document',
         'text-search-babbage-doc-001',
         'ada-search-document',
         'text-search-ada-doc-001',
         'ada-search-document',
         'curie-search-document',
         'text-search-curie-doc-001',
         'curie-search-document',
      ],
   },
   {
      name: 'Audio',
      data: ['audio-transcribe-deprecated'],
   },
   {
      name: 'Others',
      data: [
         'davinci-if:3.0.0',
         'if-davinci-v2',
         'davinci-instruct-beta:2.0.0',
         'davinci-instruct-beta',
         'babbage:2020-05-03',
         'ada:2020-05-03',
         'if-curie-v2',
         'curie:2020-05-03',
         'cushman:2020-05-03',
      ],
   },
]
